import helper from '../helper'

export const servicePrint = {
  get: (token, params) => helper.get('api/v1/print-requests-admin', token, params),
  getOne: (token, { printRequestId }) => helper.get('api/v1/print-requests-admin/' + printRequestId, token),
  delete: (token, { printRequestId }) => helper.delete('api/v1/print-requests-admin/' + printRequestId, token),
  update: (token, { data, printRequestId }) => helper.patch('api/v1/print-requests-admin/' + printRequestId, data, token)
}
